import React, { FC } from 'react'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import {
  Tabs as LaunchpadTabs,
  Tab,
  TabList,
} from '@moonpig/launchpad-components'
import { ComboboxGroup } from '@ariakit/react'
import { DepartmentType, getDepartmentByName } from '../departmentMap'
import { DepartmentRow } from '../types'

const Tabs = styled(LaunchpadTabs)`
  [role="tablist"] {
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
    
    ${s({
      gap: 8,
      justifyContent: 'flex-start',
      marginBottom: 0,
      paddingLeft: 5,
      paddingY: 4,
    })}
  }
`

const DepartmentTabsContainer = styled(ComboboxGroup)`
  position: relative;
  z-index: 3;
  ${s({
    bgcolor: 'colorBackground01',
  })}
`

type DepartmentTabsProps = {
  selectedDepartment: DepartmentType
  tabs: DepartmentRow[]
  storeId: string
  setActiveDepartment: (department: DepartmentType) => void
  searchInputRef: React.RefObject<HTMLInputElement | null>
  firstListItemlRef: React.RefObject<HTMLDivElement | null>
}

export const DepartmentTabs: FC<DepartmentTabsProps> = ({
  selectedDepartment,
  setActiveDepartment,
  tabs,
  storeId,
  searchInputRef,
  firstListItemlRef,
}) => {
  const handleTabListKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'ArrowUp') {
      e.preventDefault()
      searchInputRef.current?.focus()
    } else if (e.key === 'ArrowDown') {
      e.preventDefault()
      firstListItemlRef.current?.focus()
    }
  }

  return (
    <DepartmentTabsContainer>
      <Tabs
        data-testid="department-tabs"
        defaultValue={selectedDepartment.name}
        value={selectedDepartment.name}
        onValueChange={value => setActiveDepartment(getDepartmentByName(value))}
        onKeyDown={handleTabListKeyDown}
      >
        <TabList variant="chip">
          {tabs.map(tab => {
            const department = tab.item.value as DepartmentType
            const isGreetz = storeId === 'nl'
            return (
              <Tab
                key={department.title}
                value={department.name}
                aria-label={`select ${department.label.default} department`}
                aria-controls="suggestions-panel"
              >
                {isGreetz ? department.label.nl : department.label.default}
              </Tab>
            )
          })}
        </TabList>
      </Tabs>
    </DepartmentTabsContainer>
  )
}
